import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=488e3fa5&scoped=true"
import script from "./NoResults.js?vue&type=script&lang=js&external"
export * from "./NoResults.js?vue&type=script&lang=js&external"
import style0 from "./NoResults.scss?vue&type=style&index=0&id=488e3fa5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e3fa5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default})
